












































































































































































































































































































































































import { Vue, Component } from 'vue-property-decorator'
import { exportJson2Excel } from '@/utils/excel'
import {
  formatJson,
  resetObjValue2NoneString,
  checkNoneString
} from '@/utils/tool'
import { Form } from 'element-ui'
import { mixins } from 'vue-class-component'
import DateOption from '@/mixins/dateOption'

const payTypeList = [
  {
    id: 1,
    name: 'PayPal'
  },
  {
    id: 2,
    name: '支付宝'
  },
  {
    id: 3,
    name: 'PaymentWall'
  }
]
const coinList = [
  {
    id: 1,
    name: '$12'
  },
  {
    id: 2,
    name: '0'
  },
  {
    id: 3,
    name: '¥128'
  }
]
const gameList = [
  {
    id: 1,
    name: '宝可梦'
  },
  {
    id: 2,
    name: '王者荣耀'
  },
  {
    id: 3,
    name: '皮卡丘'
  }
]
const statusList = [
  {
    id: 1,
    name: '已付款'
  },
  {
    id: 2,
    name: '代付款'
  },
  {
    id: 3,
    name: '付款失败'
  }
]
const goodsTypeList = [
  {
    id: 1,
    name: '1年vip'
  },
  {
    id: 2,
    name: '2年vip'
  },
  {
    id: 3,
    name: '其他'
  }
]
const noticeList = [
  {
    id: 1,
    name: '通知成功'
  },
  {
    id: 2,
    name: '通知失败'
  },
  {
    id: 3,
    name: '等待通知'
  }
]
@Component({
  name: 'TradeGame'
})
export default class extends mixins(DateOption) {
  // api data
  private params = {
    orderNo: '',
    cpOrderNo: '',
    payType: '',
    discountMoney: [],
    gameId: [],
    tutuName: '',
    tutuUid: '',
    fengName: '',
    fengUid: '',
    openId: '',
    payStatus: '',
    noticeStatus: '',
    createDateStart: '',
    createDateEnd: '',
    payDateStart: '',
    payDateEnd: '',
    page: 1,
    pageCount: 20
  }
  private formParams = {
    udid: '',
    goodsType: '',
    day: 0
  }
  private detail = {
    paySerialNo: '流水号',
    payOrderNo: '订单号',
    fengUid: 'dsdads',
    fengName: '大萨达',
    tutuUid: '123sada',
    openId: '用户 open id'
  }
  // component data
  payTypeList = payTypeList
  coinList = coinList
  gameList = gameList
  statusList = statusList
  noticeList = noticeList
  goodsTypeList = goodsTypeList
  dateArrayExpire = ['', '']
  dateArrayPay = ['', '']
  tableLoading = false
  showDetail = false
  tableData: any[] = []
  selectedData: any[] = []
  totalCount = 0
  tableHeight: number = 800
  // lifecycle
  async created() {
    this.getTableData()
    // this.getAccountStatus()
    // this.getAreaList()
  }
  mounted() {
    this.$nextTick(() => {
      this.setTableHeight()
      window.addEventListener('resize', this.setTableHeight)
    })
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', this.setTableHeight)
    })
  }
  setTableHeight() {
    const filter: any = this.$refs.filter
    const filterDom: any = filter.$el
    this.tableHeight = document.body.clientHeight - 250 - filterDom.clientHeight
  }
  // methods
  getTableData() {
    this.tableLoading = true
    // let res = await getAccountList(this.params)
    for (let i = 0; i < 18; i++) {
      this.tableData.push({
        id: 1 + i,
        cpOrderNo: 'cp 订单号2131sdda',
        orderNo: '商户订单号xxxooos',
        game: '宝可梦',
        userName: 'huahua',
        payStatus: ' 已付款',
        noticeStatus: ' 等待通知',
        money: '$120',
        discountMoney: '$12',
        payType: '支付宝',
        payFinishDate: '2020-08-26 14:09:04',
        createDate: '2019-08-26 14:09:04',
        paySerialNo: '流水号',
        payOrderNo: '订单号',
        fengUid: 'dsdads',
        fengName: '大萨达',
        tutuUid: '123sada',
        openId: '用户 open id'
      })
    }
    this.tableLoading = false
    // this.tableData = res.data.dataList
    // this.totalCount = res.data.pageInfo.totalCount
  }
  handleDateChangePay(date: string[]) {
    this.params.payDateStart = date && date[0]
    this.params.payDateEnd = date && date[1]
  }
  handleDateChangeExpire(date: string[]) {
    this.params.createDateStart = date && date[0]
    this.params.createDateEnd = date && date[1]
  }
  async handleExcel() {
    // let res: any = await getAccountList({
    //   page: 1,
    //   pageCount: 3000
    // })
    // if (res.status.code === 0) {
    //   setTimeout(() => {
    //     this['$message'].success('导出成功!')
    //   }, 200)
    // } else {
    //   this['$message'].error('导出失败!')
    //   return
    // }
    // const filterVal: string[] = [
    //   'id',
    //   'accountId',
    //   'certName',
    //   'applePwd',
    //   'iphoneCount',
    //   'itouchCount',
    //   'status',
    //   'info',
    //   'createDate',
    //   'creatorName'
    // ]
    // const theader: string[] = [
    //   'ID',
    //   '开发者账号',
    //   '证书',
    //   '专用密码',
    //   'iPhone可安装数量',
    //   'iPad可安装数量',
    //   '状态',
    //   '信息',
    //   '创建时间',
    //   '创建人'
    // ]
    // const list = res.data.dataList
    // const data = formatJson(filterVal, list)
    // exportJson2Excel(theader, data)
  }

  handleSearch() {
    if (this.tableLoading) { return false }
    let params:any = { ...this.params }
    for (let i in params) {
      if (typeof params[i] === 'string') {
        params[i] = params[i].trim()
      }
    }
    this.params = params
    this.params.page = 1
    this.getTableData()
  }
  handleReset() {
    resetObjValue2NoneString(this.params, ['page', 'pageCount'])
    this.dateArrayPay = ['', '']
    this.dateArrayExpire = ['', '']
    this.params.page = 1
  }
  handleSelectionChange(list: any[]) {
    console.log(list)
    this.selectedData = list
  }
  handleSelectReverse() {
    this.selectedData = []
    let tempList: number[] = []
    let tempSelectList: number[] = []
    let indexList: number[] = []
    tempList = this.tableData.map(item => item.id)
    tempSelectList = this.selectedData.map(item => item.id)
    indexList = tempList.filter(item => !tempSelectList.includes(item))
    this.tableData.forEach(item => {
      if (indexList.includes(item.id)) this.selectedData.push(item)
    })
    if (this.selectedData.length) {
      this.selectedData.forEach(row => {
        (this.$refs['multiTable'] as any).toggleRowSelection(row)
      })
    } else {
      (this.$refs['multiTable'] as any).clearSelection()
    }
  }
  handleUpdateAll() {
    // this.setAccount(this.selectIds)
  }
  handleRefund(item: any) {
    console.log(item)
    this.$confirm('是否确认要退款?', '提示', {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(async() => {
        // let uid = ''
        // uid = item.uid
        // let res: any = await deleteAccount({ uid })
        // if (res.status.code === 0) {
        //   this['$message'].success('删除成功!')
        //   setTimeout(() => {
        //     this.getTableData()
        //   }, 1500)
        // } else {
        //   this['$message'].error('删除失败!')
        // }
      })
      .catch(() => {})
  }
  handleDetail(row: any) {
    (this.$refs.multiTable as any).toggleRowExpansion(row, true)
  }
  // computed
  get showMultiSelect() {
    return this.selectedData.length > 1
  }
  get selectCount() {
    return this.selectedData.length
  }
  get selectIds() {
    let t: number[] = []
    this.selectedData.forEach(item => {
      t.push(item.id)
    })
    let ids = t.join(',')
    return ids
  }
}
